// import moment from 'moment'
import { mapActions } from 'vuex'

// const parseDate = (date, formatFrom = 'YYYY-MM-DD', formatTo = 'DD/MM/YYYY') => {
//   return moment(date, formatFrom).format(formatTo)
// }

const prepareSave = data => {
  const register = { ...data }
  register.password_confirmation = register.password
  register.country_register = register.country_register.replace('-', '')
  register.genre = register.genre.id
  return register
}

export default {
  ...mapActions(['setupJWT', 'updateUserData']),
  doRegister () {
    this.$v.$touch()
    if (this.$v.$error) {
      this.errorTrue = true
      return
    }
    this.$http.post('v1/auth/register', prepareSave(this.register))
    .then(({data}) => {
      if (data) {
        return this.$router.push({name: 'auth.login'})
      }
    })
    .catch(({data}) => {
      this.errors = data
    })
  },
  doCheck () {
    if (this.check.tenant_id === null) {
      this.notCode = true
      return
    }
    this.isLoading = true
    this.$http.get('/v1/dweller/tenant/' + this.check.tenant_id.toUpperCase())
      .then(({data}) => {
        if (data.name) {
          this.tenant = data
          this.terms = data.terms
          this.register.tenant_id = this.check.tenant_id
          this.next = true
        }
        if (data.message) {

        }
        this.next = true
      })
      .catch(({data, meta}) => {
        this.errors = data
        this.loading = false
        this.withError = true
      })
  },
  setGenre () {

  },
  doShow () {
    this.isShowing = true
  },
  doHide () {
    this.isShowing = false
  },
  internalRegulation (status) {
    if (status) {
      this.register.internal_regulation = false
    } else {
      this.register.internal_regulation = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/register/dweller/resources/methods.js